<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <search-area
      ref="SearchArea"
      statusType="2"
      :rowKeySize="this.selectedRowKeys.length"
      batchType="2"
      parent="TemporaryManage"
      @searchQuery="searchQuery(false, false)"
      @updateQueryParam="updateQueryParam"
      @batchAction="batchAction"
    ></search-area>
    <!-- 検索区域-end -->

    <!-- ボタン操作区域 -->
    <a-col :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
      <!-- <div class="ant-alert ant-alert-info div-selected-info">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
      </div> -->

      <a-table
        ref="table"
        :columns="columns"
        class="action"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <!-- 申請時間 -->
        <div slot="startDate" slot-scope="text, record">
          <span>
            {{ moment(record.startDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.startDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 最近更新時間 -->
        <div slot="endDate" slot-scope="text, record">
          <span>
            {{ moment(record.endDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.endDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <div slot="taskStatus" slot-scope="text, record">
          <a-tag color="green">{{ $t(record.taskStatus) }}</a-tag>
        </div>

        <span slot="action" slot-scope="text, record">
          <a @click="handleOpen(record)">{{ $t('disp.flow.operate') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm
            :title="$t('msg.flow.confirm.cancel')"
            @confirm="() => handleCancel(record.processInstanceId, record.id)"
          >
            <a>{{ $t('disp.flow.cancel') }}</a>
          </a-popconfirm>
          <!-- 履歴 -->
          <a-divider type="vertical" />
          <a @click="handleHistory(record.processInstanceId, record.applyName)">{{ $t('disp.flow.history') }}</a>
        </span>
      </a-table>
    </a-col>
    <!-- table区域-end -->

    <!-- 履歴 -->
    <track-modal ref="TrackModal"></track-modal>

    <!-- 申請モーダル：申請フォームを載せる -->
    <apply-modal ref="ApplyModal" @searchQuery="searchQuery(true, false)"></apply-modal>

    <!-- コメントモーダル：コメントフォームを載せる -->
    <comment-modal ref="CommentModal" @ok="searchQuery(true, false)"></comment-modal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import SearchArea from './modules/SearchArea'
import TrackModal from './modules/TrackModal'
import CommentModal from './modules/CommentModal'

export default {
  name: 'TemporaryManage',
  mixins: [tableMixin, flowMixin],
  components: {
    JDictSelectTag,
    SearchArea,
    TrackModal,
    CommentModal,
  },
  data() {
    return {
      description: '一時保存一覧',
      // ログインユーザ情報
      loginUser: this.$store.getters.userInfo,
      disableMixinSearchQuery: true,
      showLoadingBySearch: true,
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          //align: 'center',
          //width: 91,
          dataIndex: 'processInstanceId',
          customRender: this.renderProcessInstanceId,
        },
        {
          title: this.renderApplyNameHeader,
          dataIndex: 'applyName',
          customRender: this.renderApplyName,
        },
        //{
        //  title: '流程概要',
        //  dataIndex: 'summary',
        //},
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 91,
          customRender: this.renderStarter,
        },
        {
          title: this.$t('disp.flow.starterOrg'),
          align: 'left',
          // width: 180,
          dataIndex: 'starterDepartName',
          customRender: this.renderDepartName,
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'left',
          dataIndex: 'startDate',
          //scopedSlots: { customRender: 'startDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'left',
          dataIndex: 'endDate',
          //scopedSlots: { customRender: 'endDate' },
          customRender: this.renderDate,
        },
        //{
        //  title: this.$t('disp.abstract'),
        //  align: 'left',
        //  //width: '30%',
        //  customRender: this.renderSummary,
        //},
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'taskStatus' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/temporary/list',
        cancel: '/flow/task/cancel',
      },
    }
  },
  watch: {
    '$route.params.name': {
      handler(newVal, oldVal) {
        if (this.$refs.SearchArea) {
          if (newVal) {
            this.$refs.SearchArea.$set(this.$refs.SearchArea.queryParam, 'processDefinitionName', newVal)
            this.queryParam.processDefinitionName = newVal
            //this.queryParam.modelId = this.$route.params.modelId
            this.searchQuery(false, false)

            // queryParamをクリアする
            this.$router.push({
              path: this.$route.path,
              query: Object.assign({}, this.$route.query, { _: +new Date() }),
            })
          }
          //else if (this.$route.path == '/blaze-sys/k00/k0011/TemporaryManage') {
          //  this.searchQuery(false, false)
          //}
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    let name = this.$route.params.name
    if (name) {
      this.$refs.SearchArea.$set(this.$refs.SearchArea.queryParam, 'processDefinitionName', name)
      this.queryParam.processDefinitionName = name
      //this.queryParam.modelId = this.$route.params.modelId
      this.searchQuery(false, false)

      // queryParamをクリアする
      this.$router.push({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { _: +new Date() }),
      })
    } else {
      this.searchQuery(false, false)
    }
  },
  methods: {
    updateQueryParam() {
      this.queryParam = this.$refs.SearchArea ? this.$refs.SearchArea.queryParam : {}
    },
    tagColor(user) {
      return 'blue'
    },
    tagName(user) {
      return user.realname
    },
    handleCancel(processInstanceId, id) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.cancel, { processInstanceId: processInstanceId, id: id })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleHistory(processInstanceId, title) {
      this.$refs.TrackModal.open(processInstanceId, title)
    },
    handleOpen(record) {
      // 0 下記以外
      // 1 申請ポータル
      // 2 一時保存一覧
      // 3 未処理一覧
      // 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
      // 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
      // 6 処理済一覧・非活性案件
      this.$refs.ApplyModal.popupFrom = '2'

      this.$refs.ApplyModal.title = record.applyName
      this.$refs.ApplyModal.component = record.component
      this.$refs.ApplyModal.status = record.taskStatus
      this.$refs.ApplyModal.procInstId = record.processInstanceId
      this.$refs.ApplyModal.taskId = record.id
      this.$refs.ApplyModal.modelId = record.modelId

      this.$refs.ApplyModal.handleOpen()
    },
  },
}
</script>
<style lang="less" scoped>
// /deep/ .ant-table-row-cell-ellipsis {
//   white-space: unset;
// }
</style>
